(function () {
  'use strict';

  var STYLES = [
    '.hz-inline-product-wrap{margin:1.5rem 0;max-width:300px}',
    '.hz-inline-product-wrap .hz-blog-product{border:1px solid #e8e8e8;border-radius:8px;overflow:hidden;background:#fff}',
    '.hz-inline-product-wrap .hz-blog-product__img-wrap{display:block;aspect-ratio:1;overflow:hidden}',
    '.hz-inline-product-wrap .hz-blog-product__img{width:100%;height:100%;object-fit:cover;display:block}',
    '.hz-inline-product-wrap .hz-blog-product__info{padding:12px}',
    '.hz-inline-product-wrap .hz-blog-product__name{display:block;font-size:14px;font-weight:600;text-decoration:none;color:inherit;margin-bottom:4px}',
    '.hz-inline-product-wrap .hz-blog-product__price{font-size:14px;margin:0 0 10px;color:#222}',
    '.hz-inline-product-wrap .hz-blog-product__compare-price{color:#999;margin-right:4px}',
    '.hz-inline-product-wrap .hz-blog-product__btn{width:100%;padding:10px;background:#000;color:#fff;border:none;cursor:pointer;font-size:13px;font-weight:600;letter-spacing:.04em;border-radius:4px}',
    '.hz-inline-product-wrap .hz-blog-product__btn:hover{background:#222}',
    '.hz-inline-product-wrap .hz-blog-product__btn:disabled{opacity:.6;cursor:not-allowed}',
    '.hz-inline-product-wrap .hz-blog-product__size-strip{display:none;padding:10px 12px 12px;background:#f7f7f7;border-top:1px solid #e8e8e8}',
    '.hz-inline-product-wrap .hz-blog-product__size-strip.is-open{display:block}',
    '.hz-inline-product-wrap .hz-blog-product__strip-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px}',
    '.hz-inline-product-wrap .hz-blog-product__size-label{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:#555}',
    '.hz-inline-product-wrap .hz-blog-product__size-close{background:none;border:none;font-size:16px;cursor:pointer;padding:0;line-height:1;color:#555}',
    '.hz-inline-product-wrap .hz-blog-product__size-opts{display:flex;flex-wrap:wrap;gap:6px}',
    '.hz-inline-product-wrap .hz-blog-product__size-btn{padding:7px 12px;border:1px solid #ccc;background:#fff;cursor:pointer;font-size:12px;border-radius:3px;transition:border-color .15s,background .15s,color .15s}',
    '.hz-inline-product-wrap .hz-blog-product__size-btn:hover:not([disabled]){border-color:#000;background:#000;color:#fff}',
    '.hz-inline-product-wrap .hz-blog-product__size-btn[disabled]{opacity:.35;cursor:not-allowed}',
    '.hz-inline-product-wrap .hz-blog-product__badge--sale{display:inline-block;font-size:10px;font-weight:700;text-transform:uppercase;background:#c00;color:#fff;padding:2px 6px;border-radius:2px;margin-bottom:4px}'
  ].join('');

  function injectStyles() {
    if (document.getElementById('hz-inline-product-css')) return;
    var s = document.createElement('style');
    s.id = 'hz-inline-product-css';
    // textContent is safe for CSS — no HTML parsing
    s.textContent = STYLES;
    document.head.appendChild(s);
  }

  // Escape HTML special chars before inserting into innerHTML
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Validate Shopify CDN / relative URLs — only allow https://cdn.shopify.com or relative paths
  function safeUrl(url) {
    if (!url) return '';
    var s = String(url);
    if (/^https:\/\/cdn\.shopify\.com\//i.test(s)) return s;
    if (/^\/products\//.test(s)) return s;
    return '';
  }

  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function buildCard(p) {
    var v0 = p.variants[0];
    var multi = p.variants.length > 1;
    var img = safeUrl(p.featured_image || '');

    // Prefer size, then color, then first option
    var optName = p.options[0] || 'Option';
    var optIdx = 0;
    for (var i = 0; i < p.options.length; i++) {
      var n = p.options[i].toLowerCase();
      if (n === 'size') { optName = p.options[i]; optIdx = i; break; }
      if (n === 'color' && optName === p.options[0]) { optName = p.options[i]; optIdx = i; }
    }

    // Build variant buttons via DOM (avoids innerHTML for button text)
    var varBtnFragments = [];
    if (multi) {
      var seen = Object.create(null);
      p.variants.forEach(function (v) {
        var val = v['option' + (optIdx + 1)];
        if (val && !seen[val]) {
          seen[val] = true;
          // Variant IDs are integers from Shopify — safe to embed
          var dis = v.available ? '' : ' disabled';
          varBtnFragments.push(
            '<button class="hz-blog-product__size-btn hz-atc-var" data-variant-id="' + parseInt(v.id, 10) + '"' + dis + '>'
            + esc(val) + '</button>'
          );
        }
      });
    }

    var badge = (v0.compare_at_price && v0.compare_at_price > v0.price)
      ? '<span class="hz-blog-product__badge hz-blog-product__badge--sale">Sale</span>' : '';
    var compare = (v0.compare_at_price && v0.compare_at_price > v0.price)
      ? '<s class="hz-blog-product__compare-price">' + esc(fmt(v0.compare_at_price)) + '</s>' : '';

    // Product handle from Shopify is always a URL-safe slug — safe for href
    var handle = esc(p.handle);
    var imgHtml = img
      ? '<a href="/products/' + handle + '" class="hz-blog-product__img-wrap" tabindex="-1" aria-hidden="true">'
        + '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" class="hz-blog-product__img" width="300" height="300"></a>'
      : '';

    var action = multi
      ? '<button class="hz-blog-product__btn hz-open-strip" aria-expanded="false" aria-label="' + esc('Select ' + optName) + '">Add to Cart</button>'
        + '<div class="hz-blog-product__size-strip" role="region">'
        + '<div class="hz-blog-product__strip-head">'
        + '<span class="hz-blog-product__size-label">Select ' + esc(optName) + '</span>'
        + '<button class="hz-blog-product__size-close hz-close-strip" aria-label="Close">&#x2715;</button>'
        + '</div>'
        + '<div class="hz-blog-product__size-opts">' + varBtnFragments.join('') + '</div>'
        + '</div>'
      : '<button class="hz-blog-product__btn hz-atc-direct" data-variant-id="' + parseInt(v0.id, 10) + '" aria-label="' + esc('Add ' + p.title + ' to cart') + '">Add to Cart</button>';

    return '<div class="hz-blog-product">'
      + imgHtml
      + '<div class="hz-blog-product__info">'
      + badge
      + '<a href="/products/' + handle + '" class="hz-blog-product__name">' + esc(p.title) + '</a>'
      + '<p class="hz-blog-product__price">' + compare + ' <span>' + esc(fmt(v0.price)) + '</span></p>'
      + action
      + '</div></div>';
  }

  function cartAdd(variantId, btn) {
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function () {
        btn.textContent = 'Added ✓';
        // Refresh Dawn cart count bubble
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });
        // Signal Dawn theme to refresh cart drawer
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2500);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
      });
  }

  function wireCard(wrap) {
    wrap.addEventListener('click', function (e) {
      var t = e.target;

      if (t.classList.contains('hz-open-strip')) {
        var strip = t.nextElementSibling;
        if (!strip) return;
        var open = strip.classList.toggle('is-open');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }

      if (t.classList.contains('hz-close-strip')) {
        var strip2 = t.closest
          ? t.closest('.hz-blog-product__size-strip')
          : t.parentElement && t.parentElement.parentElement;
        if (strip2) {
          strip2.classList.remove('is-open');
          var trigger = strip2.previousElementSibling;
          if (trigger && trigger.classList.contains('hz-open-strip')) {
            trigger.setAttribute('aria-expanded', 'false');
          }
        }
        return;
      }

      if (t.classList.contains('hz-atc-var') && !t.disabled) {
        cartAdd(t.getAttribute('data-variant-id'), t);
        var strip3 = t.closest ? t.closest('.hz-blog-product__size-strip') : null;
        if (strip3) {
          setTimeout(function () { strip3.classList.remove('is-open'); }, 900);
        }
        return;
      }

      if (t.classList.contains('hz-atc-direct') && !t.disabled) {
        cartAdd(t.getAttribute('data-variant-id'), t);
      }
    });
  }

  function hydrate(el) {
    var handle = el.getAttribute('data-handle');
    // Only allow lowercase letters, numbers, hyphens — standard Shopify handle format
    if (!handle || !/^[a-z0-9-]+$/.test(handle)) return;

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var wrap = document.createElement('div');
        wrap.className = 'hz-inline-product-wrap';
        // buildCard produces escaped HTML from trusted Shopify API data
        wrap.innerHTML = buildCard(product);
        wireCard(wrap);
        el.parentNode.replaceChild(wrap, el);
      })
      .catch(function (err) {
        console.warn('[hz-inline] Failed to load product:', handle, err);
        el.remove();
      });
  }

  function init() {
    injectStyles();
    [].forEach.call(document.querySelectorAll('.hz-product-embed[data-handle]'), hydrate);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
